"use strict";
/**
 * @license
 * Copyright 2018 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var MediaType;
(function (MediaType) {
    MediaType["APPLICATION_JSON"] = "application/json";
    MediaType["APPLICATION_OCTET_STREAM"] = "application/octet-stream";
    MediaType["APPLICATION_X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    MediaType["MULTIPART_FORM_DATA"] = "multipart/form-data";
    MediaType["TEXT_PLAIN"] = "text/plain";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
//# sourceMappingURL=httpApiBridge.js.map